import React, {useState} from 'react';
import TimeHeader from './TimeHeader'
import WaveHeightRow from './WaveHeightRow';
import SwellHeightRow from './SwellHeightRow'
import SwellWaveDirectionRow from './SwellWaveDirectionRow'
import SwellWavePeriodRow from './SwellWavePeriodRow'
import WindSpeed10mRow from './WindSpeed10mRow'
import WindDirection10mRow from './WindDirection10mRow'
import WindGust10mRow from './WindGust10mRow'
import Temp2mRow from './Temp2mRow'
import RainRow from './RainRow'
import CloudCoverRow from './CloudCoverRow'
import SeaLevelRow from './SeaLevelRow'
import WindSpeed80mRow from './WindSpeed80mRow';
import RatingRow from './RatingRow'

import { 
    formatDateTime
} from '../../../utils/helpers';

const ForecastDataTable = ({ forecastData, currentSpot, visibleUnits, includedHours }) => {
    const [selectedDay, setSelectedDay] = useState(0);

    if (!forecastData || !forecastData.hourly) {
        return (
            <div className="forecast-no-data mt-8 mb-[100px]">No forecast data available</div>
        );
    }

    const { hourly, hourly_units } = forecastData;

    // Filter and group data by day
    const filteredData = hourly.time?.reduce((acc, time, index) => {
        const dateTime = formatDateTime(time);
        
        // Only include times that are in our includedHours array
        if (includedHours.includes(dateTime.hour)) {
            const dayKey = dateTime.date;
            
            if (!acc[dayKey]) {
                acc[dayKey] = [];
            }
            
            acc[dayKey].push({
                time,
                index,
                dateTime
            });
        }
        
        return acc;
    }, {}) || {};

    return(
        <div className="mt-4 mb-[100px] bg-custom-charcoal/30 rounded-xl p-3">
            <div className='flex items-center justify-between gap-1 mb-3 max-w-[400px] mx-auto'>
                {Object.entries(filteredData).map(([dayKey], index) => {
                    //short day name
                    const shortDayName = new Date(dayKey).toLocaleDateString('en-US', { weekday: 'short' });
                    //day of month
                    const dayOfMonth = new Date(dayKey).getDate();
                    const isToday = new Date().toDateString() === new Date(dayKey).toDateString();
                    return(
                        <div 
                            key={dayKey} 
                            className={`text-center cursor-pointer flex-1 py-2 rounded-md  transition-all duration-200 hover:bg-custom-light-blue/20 ${
                                selectedDay === index 
                                    ? 'bg-custom-light-blue text-custom-dark hover:bg-custom-light-blue' 
                                    : ''
                            }`} 
                            onClick={() => setSelectedDay(index)}
                        >
                            <span className={`block text-xs font-medium ${selectedDay === index ? 'text-custom-dark' : 'text-custom-light-grey'}`}>
                                {isToday ? 'Today' : shortDayName}
                            </span> 
                            <span className={`block text-lg font-bold ${selectedDay === index ? 'text-custom-dark' : 'text-white'}`}>
                                {dayOfMonth}
                            </span>
                        </div>
                    )
                })} 
            </div>   
            {Object.entries(filteredData).map(([dayKey, dayData], index) => {

                return (
                    <div key={dayKey} data-key={index} className={`w-full ${selectedDay === index ? '' : 'hidden'}`}>

                        {/* horizontal scroll wrapper */}
                        <div className="overflow-x-auto">
                            <table className="forecast-table w-full text-left border-collapse pb-5 sm:table-fixed">
                                
                                <TimeHeader dayData={dayData} />

                                <tbody className="divide-y divide-custom-charcoal/50">

                                    {visibleUnits.overall_rating_score &&<RatingRow dayData={dayData} data={hourly} />}

                                    {/* heights */}

                                    {visibleUnits.wave_height && <WaveHeightRow dayData={dayData} units={hourly_units.wave_height} data={hourly.wave_height} />}

                                    {visibleUnits.swell_wave_height && <SwellHeightRow dayData={dayData} units={hourly_units.swell_wave_height} data={hourly.swell_wave_height} />}

                                    {/* period */}

                                    {visibleUnits.swell_wave_period && <SwellWavePeriodRow dayData={dayData} units={hourly_units.swell_wave_period} data={hourly.swell_wave_period} />}

                                    {/* direction */}

                                    {visibleUnits.swell_wave_direction && <SwellWaveDirectionRow dayData={dayData} units={hourly_units.swell_wave_direction} data={hourly.swell_wave_direction} />}

                                    {/* forecast */}

                                    {visibleUnits.wind_speed_10m && <WindSpeed10mRow dayData={dayData} units={hourly_units.wind_speed_10m} data={hourly.wind_speed_10m} />}

                                    {visibleUnits.wind_speed_80m && <WindSpeed80mRow dayData={dayData} units={hourly_units.wind_speed_80m} data={hourly.wind_speed_80m} />}

                                    {visibleUnits.wind_gusts_10m && <WindGust10mRow dayData={dayData} units={hourly_units.wind_gusts_10m} data={hourly.wind_gusts_10m} />}

                                    {visibleUnits.wind_direction_10m && <WindDirection10mRow dayData={dayData} units={hourly_units.wind_direction_10m} data={hourly.wind_direction_10m} />}

                                    {visibleUnits.temperature_2m && <Temp2mRow dayData={dayData} units={hourly_units.temperature_2m} data={hourly.temperature_2m} />}

                                    {visibleUnits.rain && <RainRow dayData={dayData} units={hourly_units.rain} data={hourly.rain} />}

                                    {visibleUnits.cloud_cover && <CloudCoverRow dayData={dayData} units={hourly_units.cloud_cover} data={hourly.cloud_cover} />}

                                    {visibleUnits.sea_level_height_msl && <SeaLevelRow dayData={dayData} units={hourly_units.sea_level_height_msl} data={hourly.sea_level_height_msl} />}

                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            })}          
        </div>
    )
};

export default ForecastDataTable;
